import { __rest, __assign } from 'tslib';
import React__default from 'react';
import { activeBusinessFiltersState, dataViewFacetsSelector, buildOptimizedLightDataviewElementsSelector, fixedFacetsState, MediaField, FOLDERS_FACET_NAME_BEGIN, FilterType, convertBusinessFilterFilterToBusinessFilterFacet } from '@keepeek/commons';
import { useRecoilValue } from 'recoil';
import { withSuspense } from '../withSuspense/index.js';
import BusinessFilterTypeSwitch from './BusinessFilterTypeSwitch.js';

var BusinessFilterFacet = function (_a) {
    var _b;
    var filter = _a.filter, configFilters = _a.configFilters, dataViewKey = _a.dataViewKey, rest = __rest(_a, ["filter", "configFilters", "dataViewKey"]);
    var activeFilters = useRecoilValue(activeBusinessFiltersState(dataViewKey));
    var facets = useRecoilValue(dataViewFacetsSelector(buildOptimizedLightDataviewElementsSelector({
        key: dataViewKey,
        filters: activeFilters || [],
        filtersConfiguration: configFilters || null,
        enableFacets: true
    })));
    var fixedFacets = useRecoilValue(fixedFacetsState(dataViewKey));
    var businessFilter;
    var fixedFacet = fixedFacets.find(function (ff) {
        var _a, _b;
        return ff.filter.id === filter.name ||
            ((_a = ff.filter.id) === null || _a === void 0 ? void 0 : _a.startsWith("".concat(filter.name, "."))) ||
            (filter.name === MediaField.FOLDER_ID && ((_b = ff.filter.id) === null || _b === void 0 ? void 0 : _b.startsWith(FOLDERS_FACET_NAME_BEGIN)));
    });
    if (filter.type === FilterType.FacetMulti && fixedFacet) {
        // If this is a multi-facet, we add the multi-facet to display it again and select another value
        businessFilter = fixedFacet;
    }
    else {
        businessFilter = convertBusinessFilterFilterToBusinessFilterFacet(filter, facets, activeFilters);
    }
    if (!businessFilter) {
        return null;
    }
    return (React__default.createElement(BusinessFilterTypeSwitch, __assign({ businessFilter: businessFilter, dataViewKey: dataViewKey }, rest, { noFacetsCount: (_b = filter === null || filter === void 0 ? void 0 : filter.hideFacetOccurrences) !== null && _b !== void 0 ? _b : false })));
};
var BusinessFilterFacet$1 = withSuspense(BusinessFilterFacet);

export { BusinessFilterFacet$1 as default };
//# sourceMappingURL=BusinessFilterFacet.js.map
